module.exports = __webpack_public_path__ + "static/media/Fidelity.1651fffa.png";